<template>
  <page-container aside>
    <template #aside>
      <bp-input-file
        v-model="form.picture"
        is-image
        dimensions="256 x 256"
        title="Imagem do produto"
        :supporting-text="imageSupportingText(product)"
      />
    </template>

    <template #default>
      <h2 class="mb-2">
        Informações básicas
      </h2>
      <h4 class="pb-3 mb-6 text-neutral-400">
        Através dessas informações seu cliente vai identificar o seu produto.
      </h4>

      <event-basic-information
        v-if="product.type_product == 'onsite_event'"
        :form="form"
      />

      <product-basic-information
        v-else
        :form="form"
        :errors="errors"
        :loading="loading"
        :product="product"
        :edit="true"
        @submit="onSubmit"
      />

      <div class="d-flex flex-column flex-lg-row justify-content-between mt-9">
        <button
          class="btn btn-new-primary order-lg-1 mb-5 mb-lg-0"
          :disabled="!isValid"
          @click="onSubmit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
        <button class="btn btn-new-secondary" @click="$router.go(-1)">
          Cancelar
        </button>
      </div>
    </template>
  </page-container>
</template>

<script>
import ProductBasicInformation from "@/components/product/BasicInformation";
import EventBasicInformation from "@/components/product/events/BasicInformation.vue";
import EditProductMixin from "@/mixins/editProduct.js";

export default {
  mixins: [EditProductMixin],
  components: { ProductBasicInformation, EventBasicInformation },
  computed: {
    isValid() {
      let requiredFields = ["name", "description", "category_id"];
      if (this.product.type_product == "onsite_event")
        requiredFields = [
          ...requiredFields,
          ...[
            "event_location",
            "event_address",
            "event_start_at",
            "event_end_at"
          ]
        ];
      return (
        !requiredFields.find(f => !this.form[f]) &&
        this.form.name.length <= 64 &&
        this.form.description.length <= 980
      );
    }
  },
  methods: {
    imageSupportingText(product) {
      return product.type_product == "onsite_event"
        ? "Imagem exibida no checkout e enviada no e-mail de confirmação de compra do ingresso."
        : "Imagem exibida no checkout para seus compradores.";
    }
  },
  mounted() {
    this.successLoad();
  }
};
</script>
